module.exports = __webpack_public_path__ + "static/icons/icon-mensaje-meta-alcanzada.f9876f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-mensaje-meta-alcanzada.svg
// module id = beg4
// module chunks = 1